import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
// import { MdPerson, MdBusiness, MdChevronRight } from "react-icons/md";
import { MdClose } from "react-icons/md";
import { AccountType } from "./AccountTypeModal";
import styles from "./LoginModal.module.css";
import Register from "../LoginPage/Register/Register";
import { Toast } from "primereact/toast";
import useLoginAPI from "../../../api/useLogin";
import customers from "razorpay/dist/types/customers";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logInUserFunc } from "../../../redux/userState";
import loginBanner from "../../../assets/images/wheel_balancing_1784112229552.jpg";
import { refreshProductList } from "../../../redux/productSlice";

type Step = "username" | "otp";
type View = "login" | "register";

interface LoginModalProps {
  visible: boolean;
  onHide: () => void;
  accountType: AccountType;
  onLoginSuccess: () => void;
}
export default function LoginModal({
  visible,
  onHide,
  accountType,
  onLoginSuccess,
}: LoginModalProps) {
  const toast = useRef<Toast>(null);
  const dispatch = useDispatch();
  const { sendOTP, generateToken } = useLoginAPI();
  const [username, setUsername] = useState("");
  const [step, setStep] = useState<Step>("username");
  const [otp, setOtp] = useState("");
  const [sendingOtp, setSendingOtp] = useState(false);
  const [view, setView] = useState<View>("login");
  const [checkbox, setCheckbox] = useState(false);
  const [error, setError] = useState("");
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(30);
  // console.log("visible", visible);
  const resetAndClose = () => {
    setStep("username");
    setView("login");
    setUsername("");
    setOtp("");
    setError("");
    onHide();
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isResendDisabled && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (!countdown) {
      setIsResendDisabled(false);
      setCountdown(30);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isResendDisabled, countdown]);
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH;
  const validateCustomer = (value: string) => /^\d{10}$/.test(value.trim());
  const validateCorporate = (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) || value.trim().length > 0;

  const handleSendOtp = async () => {
    if (!checkbox) {
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Accept the Terms & Conditions",
      });
      return;
    }
    const isValid =
      accountType === "customer"
        ? validateCustomer(username)
        : validateCorporate(username);

    if (!isValid) {
      setError(
        accountType === "customer"
          ? "Enter a valid 10-digit phone number"
          : "Enter a valid username or email",
      );
      return;
    }

    setError("");
    setSendingOtp(true);
    try {
      const payload = {
        username: username,
        roles:
          accountType === "customer"
            ? ["ROLE_CUSTOMER"]
            : [
                "ROLE_CORPORATE_USER",
                "ROLE_CORPORATE_ADMIN",
                "ROLE_FLEET_OWNER",
                "ROLE_FLEET_USER",
              ],
        is_for_login: true,
      };

      const response: any = await sendOTP(payload);
      if (response?.status === 200) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.data.message,
        });
        setStep("otp");
        // navigate("/");
      } else if (response?.response?.status === 400) {
        toast.current?.show({
          severity: "error",
          summary: "Failed",
          detail: response.response.data.error,
        });
      } else if (response?.status === 404) {
        toast.current?.show({
          severity: "error",
          summary: "Failed",
          detail: response?.response?.data?.error,
        });
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "Failed to send OTP",
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: error?.response?.data?.error || "Failed to send OTP",
      });
    } finally {
      setSendingOtp(false);
    }
  };

  const handleResendOtp = async () => {
    setIsResendDisabled(true);
    setOtp("");

    await handleSendOtp();
  };

  const handleVerifyOtp = async () => {
    if (!checkbox) {
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Accept the Terms & Conditions",
      });
      return;
    }
    if (otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP");
      return;
    }

    const payload = {
      username: username,
      login_panel: "WEB",
      otp: otp,
    };

    const response: any = await generateToken(payload);
    if (response?.status === 200 || response?.status === 201) {
      // console.log(" before dispatch");
      localStorage.setItem("authTokens", JSON.stringify(response.data.tokens));
      dispatch(refreshProductList());
      dispatch(logInUserFunc());
      // console.log("after dispatch");
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: response?.data?.message,
      });
      onLoginSuccess();
      resetAndClose();
      navigate(`${basePath}`);
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    }
  };
  return (
    <div>
      <Toast ref={toast} baseZIndex={999999} />
      <Dialog
        visible={visible}
        onHide={resetAndClose}
        showHeader={false}
        modal
        dismissableMask={false}
        className={styles.dialog}
        contentClassName={styles.dialogContent}
      >
        <div className={styles.modal}>
          <div className={styles.hero}>
            <button
              type="button"
              className={styles.closeBtn}
              aria-label="Close"
              onClick={resetAndClose}
            >
              <MdClose size={20} />
            </button>
          </div>

          <div className={styles.body}>
            {view === "login" ? (
              <>
                {/* {step === "username" && (
                  <>
                    <h2 className={styles.title}>
                      {accountType === "customer"
                        ? "User LogIn"
                        : "Corporate User  LogIn"}
                    </h2>
                    <p className={styles.subtitle}>
                      Enter your details to access your account
                    </p>
                    <label className={styles.label}>
                      {accountType === "customer"
                        ? "Phone Number"
                        : "Username / Email"}
                    </label>
                    <div className={styles.phoneRow}>
                      {accountType === "customer" ? (
                        <div className={styles.phoneField}>
                          <span className={styles.countryCode}>+91</span>
                          <span className={styles.divider} />
                          <input
                            type="tel"
                            inputMode="numeric"
                            maxLength={10}
                            placeholder="8790000000"
                            className={styles.input}
                            value={username}
                            onChange={(e) =>
                              setUsername(e.target.value.replace(/\D/g, ""))
                            }
                          />
                        </div>
                      ) : (
                        <div className={styles.phoneField}>
                          <input
                            type="text"
                            placeholder="Enter Username/Email"
                            className={styles.input}
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                      )}
                      <button
                        type="button"
                        className={styles.sendOtpBtn}
                        onClick={handleSendOtp}
                        disabled={sendingOtp}
                      >
                        {sendingOtp ? "Sending..." : "Send OTP"}
                      </button>
                    </div>

                    <label className={styles.label}>OTP</label>
                    <div className={styles.otpField}>
                      <input
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        placeholder="Enter 6-digit OTP"
                        className={styles.input}
                        value={otp}
                        disabled
                      />
                    </div>
                    {error && <p className={styles.error}>{error}</p>}

                    <button
                      type="button"
                      className={styles.continueBtn}
                      onClick={handleSendOtp}
                    >
                      Continue
                    </button>

                    <div className="by-continuing">
                      <input
                        type="checkbox"
                        className="checkbox"
                        checked={checkbox}
                        onChange={(e) => setCheckbox(e.target.checked)}
                      />{" "}
                      <div>
                        I Agree To Mechmiles{" "}
                        <a
                          href="/terms"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms & Conditions
                        </a>{" "}
                        And{" "}
                        <a
                          href="/privacy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>
                    </div>
                  </>
                )} */}
                {step === "username" && (
                  <>
                    <div className={styles.imageWrapper}>
                      <img
                        src={loginBanner}
                        alt="Wheel Balancing"
                        className={styles.bannerImage}
                      />
                    </div>
                    <div className={styles.contentWrapper}>
                      <h2 className={styles.title}>
                        {accountType === "customer"
                          ? "User Login"
                          : "Corporate User Login"}
                      </h2>

                      <p className={styles.subtitle}>
                        Enter your details to access your account
                      </p>

                      <label className={styles.label}>
                        {accountType === "customer"
                          ? "Phone Number"
                          : "Username / Email"}
                      </label>

                      <div className={styles.phoneRow}>
                        {accountType === "customer" ? (
                          <div className={styles.phoneField}>
                            <span className={styles.countryCode}>+91</span>
                            <span className={styles.divider} />
                            <input
                              type="tel"
                              inputMode="numeric"
                              maxLength={10}
                              placeholder="8790000000"
                              className={styles.input}
                              value={username}
                              onChange={(e) =>
                                setUsername(e.target.value.replace(/\D/g, ""))
                              }
                            />
                          </div>
                        ) : (
                          <div className={styles.phoneField}>
                            <input
                              type="text"
                              placeholder="Enter Username/Email"
                              className={styles.input}
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                            />
                          </div>
                        )}

                        <button
                          type="button"
                          className={styles.sendOtpBtn}
                          onClick={handleSendOtp}
                          disabled={sendingOtp}
                        >
                          {sendingOtp ? "Sending..." : "Send OTP"}
                        </button>
                      </div>

                      {error && <p className={styles.error}>{error}</p>}

                      <div className="by-continuing">
                        <input
                          type="checkbox"
                          className="checkbox"
                          checked={checkbox}
                          onChange={(e) => setCheckbox(e.target.checked)}
                        />
                        <div>
                          I Agree To Mechmiles{" "}
                          <a
                            href="/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms & Conditions
                          </a>{" "}
                          And{" "}
                          <a
                            href="/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </a>
                        </div>
                      </div>

                      <p className={styles.registerRow}>
                        Don't have an account?{" "}
                        <a
                          onClick={() => setView("register")}
                          style={{ cursor: "pointer", color: "#642088" }}
                        >
                          Register
                        </a>
                      </p>
                    </div>
                  </>
                )}

                {/* {step === "otp" && (
                  <>
                    <h2 className={styles.title}>Verify OTP</h2>
                    <p className={styles.subtitle}>
                      Enter the 6-digit code sent to{" "}
                      {accountType === "customer"
                        ? `+91 ${username}`
                        : username}
                    </p>

                    <label className={styles.label}>OTP</label>
                    <div className={styles.otpField}>
                      <input
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        placeholder="Enter 6-digit OTP"
                        className={styles.input}
                        value={otp}
                        onChange={(e) =>
                          setOtp(e.target.value.replace(/\D/g, ""))
                        }
                        autoFocus
                      />
                    </div>
                    <div className={styles.resendRow}>
                      <button
                        type="button"
                        className={styles.resendLink}
                        onClick={handleResendOtp}
                      >
                        Resend OTP
                      </button>
                    </div>

                    {error && <p className={styles.error}>{error}</p>}

                    <button
                      type="button"
                      className={styles.continueBtn}
                      onClick={handleVerifyOtp}
                    >
                      Continue
                    </button>
                  </>
                )} */}
                {step === "otp" && (
                  <>
                    <div className={styles.imageWrapper}>
                      <img
                        src={loginBanner}
                        alt="Wheel Balancing"
                        className={styles.bannerImage}
                      />
                    </div>

                    <div className={styles.contentWrapper}>
                      <h2 className={styles.title}>Verify OTP</h2>

                      <p className={styles.subtitle}>
                        Enter the 6-digit code sent to{" "}
                        {accountType === "customer"
                          ? `+91 ${username}`
                          : username}
                      </p>

                      <label className={styles.label}>OTP</label>

                      <div className={styles.otpField}>
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          placeholder="Enter 6-digit OTP"
                          className={styles.input}
                          value={otp}
                          onChange={(e) =>
                            setOtp(e.target.value.replace(/\D/g, ""))
                          }
                          autoFocus
                        />
                      </div>

                      <div className={styles.resendRow}>
                        <button
                          type="button"
                          className={styles.resendLink}
                          onClick={handleResendOtp}
                        >
                          Resend OTP
                        </button>
                      </div>

                      {error && <p className={styles.error}>{error}</p>}

                      <button
                        type="button"
                        className={styles.continueBtn}
                        onClick={handleVerifyOtp}
                      >
                        Continue
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <Register
                accountType={accountType}
                onBackToLogin={() => setView("login")}
                onRegisterSuccess={() => {
                  onLoginSuccess();
                  resetAndClose();
                  navigate(`${basePath}`);
                }}
              />
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
}
